import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';
import { StringTypes } from '../../models/wellInfo';
import { CTWOTubingODs, CTWOTubingOD, CasingOrTubingId, CasingOrTubingDirection } from '../../models/models';
import { WellInfo } from '../../services/nswag/nswagclient';

@Component({
    selector: 'simulation-well-information',
    templateUrl: './well-information.component.html',
    styleUrls: ['../job-simulator/job-simulator.component.css'],
    standalone: false
})
export class WellInformationComponent implements OnInit {
  @Output() wellInfoChanged = new EventEmitter<WellInfo>();

  stringTypes: SelectItem[] = [];
  ctwoTubingODs: SelectItem[] = [];
  hozTubingODs: SelectItem[] = [];
  selectedCTWOTubingOD: CTWOTubingOD | null = null;
  selectedHozTubingOD: CTWOTubingOD | null = null;
  public wellInfo: WellInfo = new WellInfo();

  constructor() { }

  ngOnInit() {
    this.stringTypes = [
      { label: StringTypes.coilTubing, value: StringTypes.coilTubing },
      { label: StringTypes.jointTubing, value: StringTypes.jointTubing }
    ];
    this.ctwoTubingODs = this.getCTWOTubingODs();
    this.hozTubingODs = this.ctwoTubingODs;
  }

  getCTWOTubingODs(): SelectItem[] {
    const tubingODs: SelectItem[] = CTWOTubingODs;
    return tubingODs.sort((a, b) => {
      const left = String(a.label ?? '');
      const right = String(b.label ?? '');
      if (left < right) { return -1; }
      if (left > right) { return 1; }
      return 0;
    });
  }

  setLateralLengthEst() {
    if (this.wellInfo && this.wellInfo.tvd && this.wellInfo.md) {
      this.wellInfo.lateralLengthEst = this.wellInfo.md - this.wellInfo.tvd;
    }
    this.updateWellInfo();
  }

  setCTWOTubingOD() {
    if (!this.selectedCTWOTubingOD) {
      return;
    }
    this.wellInfo.ctWoTubingOd = this.selectedCTWOTubingOD.value;
    this.wellInfo.ctWoTubingOdId = this.selectedCTWOTubingOD.id;
  }

  setHozTubingOD() {
    if (!this.selectedHozTubingOD) {
      return;
    }
    this.wellInfo.hozTubingOd = this.selectedHozTubingOD.value;
    this.wellInfo.hozTubingOdId = this.selectedHozTubingOD.id;
  }

  setSelectedTubingODs() {
    this.selectedCTWOTubingOD = { id: this.wellInfo.ctWoTubingOdId, value: this.wellInfo.ctWoTubingOd };
    this.selectedHozTubingOD = { id: this.wellInfo.hozTubingOdId, value: this.wellInfo.hozTubingOd };
  }

  updateCsgId(csgId: number | undefined) {
    this.wellInfo.csgId = csgId;
  }

  updateWellInfo() {
    this.wellInfoChanged.emit(this.wellInfo);
  }
}
